<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BButton,
  BForm,
  BFormInput,
  BFormGroup,
  BCard,
  BLink,
  BCardTitle,
  BCardText,
  BInputGroup,
  BInputGroupAppend,
  BFormCheckbox,
  BSpinner,
} from 'bootstrap-vue'
import { required, email } from '@core/utils/validations/validations'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import api from '@/services/api'
import { jwtService } from '@/services/jwt'
import { toggleSending } from '@/mixins/loading'
import toasted from '@/mixins/toasted'

export default {
  components: {
    // BSV
    BButton,
    BForm,
    BFormInput,
    BFormGroup,
    BCard,
    BCardTitle,
    BLink,
    BCardText,
    BInputGroup,
    BInputGroupAppend,
    BFormCheckbox,
    BSpinner,
    ValidationProvider,
    ValidationObserver,
  },
  mixins: [togglePasswordVisibility, toggleSending, toasted],
  data() {
    return {
      phone: '',
      password: '',
      status: '',
      // validation rules
      required,
      email,
    }
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
  },
  methods: {
    async loginUser() {
      try {
        this.startSending()
        // let p = this.phone.replace(/\s|\+/g, '')
        // if (this.phone.startsWith('+998')) {
        //   p = p.slice(3)
        // }
        const response = await api.auth.login({
          // eslint-disable-next-line radix
          login: this.phone,
          password: this.password,
        })
        jwtService.setToken(response.data.token)
        await this.$router.push({
          name: 'home',
        })
      } catch (e) {
        this.toastErrorResponse(e)
      } finally {
        this.finishSending()
      }
    },
  },
}
</script>

<template>
  <div class="auth-wrapper auth-v1 px-2">
    <div class="auth-inner py-2">
      <!-- Login v1 -->
      <b-card class="mb-0">
        <b-link class="brand-logo d-flex align-items-center justify-content-center">
          <img
            src="logo.png"
            alt="logo.png"
            width="32"
            height="32"
          >

          <h2 class="brand-text text-primary ml-1 mb-0">
            Ko'mirchi
          </h2>
        </b-link>

        <b-card-title class="mb-1">
          Welcome to Ko'mirchi! 👋
        </b-card-title>
        <b-card-text class="mb-2">
          Please sign-in to your account
        </b-card-text>

        <!-- form -->
        <validation-observer
          ref="loginForm"
          #default="{ invalid }"
        >
          <b-form
            class="auth-login-form mt-2"
            @submit.prevent="loginUser"
          >
            <!-- email -->
            <!-- PHONE -->
            <b-form-group
              label="Phone"
              label-for="userPhone"
            >
              <validation-provider
                #default="{ errors }"
                name="phone"
                rules="required"
              >
                <!--      v-mask="'+998 ## ### ## ##'"           -->
                <b-form-input
                  id="userPhone"
                  v-model="phone"
                  :state="errors.length > 0 ? false : null"
                  name="register-phone"
                  placeholder="Login"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <!-- password -->
            <b-form-group>
              <div class="d-flex justify-content-between">
                <label for="password">Password</label>
                <!--                <b-link :to="{ name: 'auth-forgot-password-v1' }">-->
                <!--                  <small>Forgot Password?</small>-->
                <!--                </b-link>-->
              </div>
              <validation-provider
                #default="{ errors }"
                name="Password"
                rules="required"
              >
                <b-input-group
                  class="input-group-merge"
                  :class="errors.length > 0 ? 'is-invalid' : null"
                >
                  <b-form-input
                    id="password"
                    v-model="password"
                    :type="passwordFieldType"
                    class="form-control-merge"
                    :state="errors.length > 0 ? false : null"
                    name="login-password"
                    placeholder="Password"
                  />

                  <b-input-group-append is-text>
                    <feather-icon
                      class="cursor-pointer"
                      :icon="passwordToggleIcon"
                      @click="togglePasswordVisibility"
                    />
                  </b-input-group-append>
                </b-input-group>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <!-- checkbox -->
            <b-form-group>
              <b-form-checkbox
                id="remember-me"
                v-model="status"
                name="checkbox-1"
              >
                Remember Me
              </b-form-checkbox>
            </b-form-group>

            <!-- submit button -->
            <b-button
              variant="primary"
              class="w-100"
              type="submit"
              :disabled="invalid"
            >
              <span
                v-if="sending"
                class="pr-1"
              >
                <b-spinner small />
              </span>
              <span>Sign in</span>
            </b-button>
          </b-form>
        </validation-observer>
      </b-card>
    </div>
  </div>
</template>

<style lang="scss">
@import "@core/scss/vue/pages/page-auth.scss";
</style>
